import { useState } from "react"
import { useLocation } from "wouter"

const works = [
  {
    id: 1,
    title: "OKX Web3 Growth",
    image: "/image-1.png",
    tags: ["Web3", "0→1"],
    desc: "I led Web3 Growth, Marketplace, and Discover. Goal: building a growth ecosystem where every user action creates on-chain value, deepens commitment, and compounds into long-term participation. Alongside leadership, contributing as a key IC on high-impact initiatives.",
    outcome: "On-chain growth · Long-term participation",
    year: "2024–Now",
    link: "/case/okx",
    internal: true,
  },
  {
    id: 2,
    title: "Pay with Grab",
    image: "/image-2.png",
    tags: ["FinTech", "Strategy"],
    desc: "Revolutionizing the payment experience for online/offline payments, payment onboarding, financial product activation, and more. A strategic approach with guiding principles for all payment products and a library of components & patterns for crafting payment designs.",
    outcome: "8 markets · Millions of transactions",
    year: "2020",
    link: "/case/grab",
    internal: true,
  },
  {
    id: 3,
    title: "Grab Passenger App Redesign",
    image: "/image-3.png",
    tags: ["Super App", "Scale"],
    desc: "Redesigning the transport booking experience for Grab App. How do I work within a hyper-growth startup and design a rational but still meaningful transport experience that impacts millions of people? A design story from the largest transportation platform in Southeast Asia.",
    outcome: "187M users across SEA",
    year: "2019",
    link: "https://uxdesign.cc/redesigning-the-transport-booking-experience-for-grab-app-52fbe796c36c",
  },
  {
    id: 4,
    title: "DeFi Earn Experience",
    image: "/image-9-defi.jpg",
    tags: ["DeFi", "Redesign"],
    highlight: "Led DeFi design",
    desc: "A comprehensive redesign of the DeFi Earn product — making the investing experience simpler, more trustworthy, and accessible to a broader audience.",
    outcome: "",
    year: "2024",
    cta: "Read Case Study",
    link: "/case/defi",
    internal: true,
  },
  {
    id: 5,
    title: "SwiftUI + ProtoPie",
    image: "/image-5.gif",
    tags: ["Prototyping", "Craft"],
    desc: "Exploring the intersection of native SwiftUI development and advanced ProtoPie prototyping to create high-fidelity, production-grade interaction prototypes that bridge design and engineering.",
    outcome: "Design × Engineering",
    year: "2024",
    link: "/swift",
    internal: true,
  },
  {
    id: 6,
    title: "Other Works",
    image: "/image-6.gif",
    tags: ["Various"],
    desc: "A collection of other design work spanning product design, interaction design, design systems, and exploratory projects across different companies and contexts.",
    outcome: "14+ years · Multiple platforms",
    year: "2012–Now",
    link: "/other-works",
    internal: true,
  },
]

export default function Work() {
  const [hovered, setHovered] = useState(null)
  const [, navigate] = useLocation()

  function handleClick(work) {
    if (!work.link) return
    if (work.internal) {
      navigate(work.link)
    } else {
      window.open(work.link, "_blank", "noopener noreferrer")
    }
  }

  return (
    <div className="page-panel">
      <div className="work-layout">

        <div className="work-layout-header">
          <div className="panel-tag">Portfolio</div>
          <h2 className="panel-title">Selected<br />Work</h2>
          <p className="panel-subtitle">
            Product design across Web3, crypto, fintech, and super-app ecosystems.
            Systems thinking, scale, and measurable impact.
          </p>
        </div>

        <div className="work-gallery">
          {works.map((work) => (
            <div
              key={work.id}
              className={`work-card${work.link ? " is-clickable" : ""}`}
              onMouseEnter={() => setHovered(work.id)}
              onMouseLeave={() => setHovered(null)}
              onClick={() => handleClick(work)}
            >
              <div className="work-card-image">
                <img src={work.image} alt={work.title} />
                <div className={`work-card-overlay${hovered === work.id ? " is-visible" : ""}`}>
                  <p className="work-card-desc">{work.desc}</p>
                  {work.outcome && <p className="work-card-outcome">{work.outcome}</p>}
                  {work.highlight && <p className="work-card-highlight">{work.highlight}</p>}
                  {work.link && (
                    <p className="work-card-cta">
                      {work.cta ? `${work.cta} →` : work.internal ? "View Gallery →" : "Read Case Study →"}
                    </p>
                  )}
                </div>
              </div>

              <div className="work-card-info">
                <span className="work-card-num">
                  {String(work.id).padStart(2, "0")}
                </span>
                <div className="work-card-body">
                  <div className="work-card-title">{work.title}</div>
                  <div className="work-card-tags">
                    {work.tags.map((tag) => (
                      <span key={tag} className="work-tag">{tag}</span>
                    ))}
                  </div>
                </div>
                <span className="work-card-year">{work.year}</span>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  )
}
